import { PolymerElement, html } from '@polymer/polymer/polymer-element';

class ZuiDialogContent extends PolymerElement {
  static get properties() {
    return {};
  }

  constructor() {
    super();
  }

  ready() {
    super.ready();
  }

  static get template() {
    return html`
      <style>
        :host div{margin:5px 0;max-height:10000px;-webkit-transition:height 1s cubic-bezier(0.25, 0.8, 0.25, 1);transition:height 1s cubic-bezier(0.25, 0.8, 0.25, 1)}
      </style>
      <div> <slot></slot> </div>
    `;
  }

}

customElements.define('zui-dialog-content', ZuiDialogContent);